import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

// Constants
import { GET_POPUP_TYPES } from "constants/popupConfig";

// Hooks
import { useGTM } from "hooks/useGTM";

// Selectors
import * as authSelectors from "redux/auth/selectors";
import * as userSelectors from "redux/user/selectors";
import { useTogglePopup } from "./useTogglePopup";

export const useCheckBalance = (checkIsAuth = true) => {
  const navigate = useNavigate();
  const location = useLocation();
  const GTM = useGTM();
  const balance = useSelector(userSelectors.balance);
  const isAuthenticated = useSelector(authSelectors.isAuthenticated);

  const { openPopup } = useTogglePopup();

  return () => {
    // Create a new URLSearchParams object
    const params = new URLSearchParams(location.search);
    // Remove the existing 'popup' parameter
    params.delete("popup");
    if (isAuthenticated && balance <= 0) {
      GTM.openDeposit();
      // Add the new 'popup' parameter
      params.append("popup", GET_POPUP_TYPES.popup.deposit);
      // Navigate to the updated URL
      navigate(
        {
          search: `?${params.toString()}`,
        },
        { replace: true },
      );
      return false;
    }
    if (!isAuthenticated && checkIsAuth) {
      // Add the new 'popup' parameter
      openPopup(GET_POPUP_TYPES.popup.signUp);
      return false;
    }
    return true;
  };
};
